isNumberKey = function (evt) {
    $(evt.target).val(evt.target.value.replace(/[^0-9]/g, ''))
}

isCharacterKey = function (evt) {
    $(evt.target).val(evt.target.value.replace(/[^a-zA-Z]/g, ''))
}

isDomainKey = function (evt) {
    $(evt.target).val(evt.target.value.replace(/[^a-zA-Z0-9\-_.@]/g, ''))
}

registerNumberOnly = function () {
    $('.js-number-only').on('change textInput input', isNumberKey);
};
